import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowBendDownRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 256,
	height: 256,
	viewBox: "0 0 256 256",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M229.66,178.34a8,8,0,0,1,0,11.32l-48,48a8,8,0,0,1-11.32-11.32L204.69,192H112A56.06,56.06,0,0,1,56,136V32a8,8,0,0,1,16,0V136a40,40,0,0,0,40,40h92.69l-34.35-34.34a8,8,0,0,1,11.32-11.32Z",
		fill: "currentColor"
	})
});
export default SvgArrowBendDownRight;
